import { Component, Vue } from 'vue-property-decorator';
import categoryFirstLevelModule from '@/store/modules/category-first-level.module'
import { CategoryFirstLevel } from '@/shared/dtos/category-first-level';
import DxDataGrid, { DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';



@Component({
    components: {
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxFilterRow,
        DxFilterPanel,
        DxExport,
        DxColumnChooser
    },
})

export default class CategoryFirstLevelLista extends Vue {

    public pageSize: number = 15;
    public maxWidth: number = 500;
    public addHidden = true;
    public loading = false;
    public search = '';
    public categoryFirstLevelCode: CategoryFirstLevel = new CategoryFirstLevel();

    public get categoryFirstLevelList() {
        return categoryFirstLevelModule.categories;
    }

    public get columns() {
        return [
            { dataField: 'id', allowEditing: false },
            { dataField: 'code', caption: this.$tc('maestro-configuracion.codigo'), allowEditing: true },
            { dataField: 'description', caption: this.$tc('maestro-configuracion.descripcion'), allowEditing: true },
            { dataField: 'externalID', caption: this.$tc('maestro-configuracion.externalID'), allowEditing: false },
        ]
    }

    public mounted() {
        categoryFirstLevelModule.getCategoriesFirstLevel();
    }

    public rowInserted(e: any) {
        categoryFirstLevelModule.insertarCategoryFirstLevel(e.data);
    }

    public rowUpdated(e: any) {
        categoryFirstLevelModule.modificarCategoryFirstLevel(e.data);
    }

    public rowRemoved(e: any) {
        categoryFirstLevelModule.eliminarCategoryFirstLevel(e.key);
    }

    public initNewRow(e: any) {
        e.data.id = 0;
    }

    public syncCategories(){
        categoryFirstLevelModule.syncCategories();
    }
}